import { Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { ProvidersComponent } from './components/providers/providers.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReportsComponent } from './components/reports/reports.component';
import { HomeComponent } from './components/home/home.component';
import { canActivateAuthRole } from './guards/keycloak.guard';
import { authGuard } from './guards/auth.guard';
import { RegisterComponent } from './components/register/register.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'providers',
    component: ProvidersComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'applications',
    component: ApplicationsComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [canActivateAuthRole, authGuard],
    data: { role: 'manage-account' },
  },
  { path: '**', redirectTo: 'dashboard' },
];
